/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI75090ResActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: boolean;
  
};
    
  
    
export type IAPI75090ResOtherDataObjMapValueObj = {};
    
  
    
export interface IAPI75090ResOtherDataObj {
  
  /** String */
  mapKey?: IAPI75090ResOtherDataObjMapKeyObj;
  
  /** Object */
  mapValue?: IAPI75090ResOtherDataObjMapValueObj;
  
};
    
  
    
export interface IAPI75090ResTreeDataItem {
  
  /** 节点名称 */
  nodeName?: string;
  
  /** 岗位名称 */
  jobName?: string;
  
};
    
  



export interface API75090Req {
  
  /** 聊天记录id */
  chatId: string;
  /** 聊天内容 */
  chatContent: string;
  /** 聊天记录id */
  chatId?: string;
  /** 聊天内容 */
  chatContent?: string;
};



export interface API75090Res {
  /**   */
  id?: string;
  /**   */
  sendTime?: string;
  /**   */
  content?: string;
  /**   */
  source?: string;
  /** ActionResp  */
  actions?: IAPI75090ResActionsItem[];
  /**   */
  timesTotal?: number;
  /**   */
  timesLeft?: number;
  /**   */
  isLine?: boolean;
  /** (该参数为map)  */
  otherData?: IAPI75090ResOtherDataObj;
  /**   */
  sessionToken?: string;
  /** TreeNodeResult  */
  treeData?: IAPI75090ResTreeDataItem[];
  
};


// 接口函数 75090 修改会议纪要

export interface IUsePostAPI75090Return {
  /** 修改会议纪要: 接口请求状态 */
  isAPI75090Loading: boolean;
  /** 修改会议纪要: 接口请求返回数据 */
  dataAPI75090: API75090Res;
  /**  修改会议纪要: 接口数据请求方法 */
  fetchAPI75090Data: (inputs: API75090Req, config?: YWRequestConfig) => Promise<API75090Res>;
  /** 修改会议纪要: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI75090 = ():IUsePostAPI75090Return => {
  let isMount = true;
  const [isAPI75090Loading, setIsAPI75090Loading] = useState(false);
  const [dataAPI75090, setDataAPI75090] = useState<API75090Res>({} as API75090Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/meeting/modifyChatRecord`;

  const fetchAPI75090Data = async (inputs: API75090Req, config?: YWRequestConfig): Promise<API75090Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API75090Req>) || {}) as API75090Req;
    
  
    if ( isMount ) {
      setIsAPI75090Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API75090Res>(`${basePath}/yoaichat-web/chat/meeting/modifyChatRecord`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI75090(res || {} as API75090Res);
        setIsAPI75090Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI75090Loading(false);
      }
      return false as unknown as API75090Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI75090Loading,
    dataAPI75090,
    fetchAPI75090Data,
    requestUrl,
  }
}

